import { getAppLanguagesMap } from "../constants/workerOnboarding";

const languages = getAppLanguagesMap();

export default languages;
